import { Box, Button, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { styled, ThemeProvider } from '@mui/material/styles';
import rightArrow from '../../../assets/icons/arrow-right.svg'
import leftArrow from '../../../assets/icons/arrow-left.svg';
import { createTheme } from '@mui/material/styles';

const RightAlignedTab = styled(Tab)({
    display: 'flex !important',
    justifyContent: 'flex-end !important',
    textAlign: 'right !important',
    alignItems:"start",
    paddingRight: '16px !important'
});

const createCustomTheme = (isSmallScreen) => createTheme({
    components: {
        MuiTabs: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    textAlign: 'right',
                    justifyContent: "start",
                    alignItems:"start",
                    '& .MuiTab-root': {
                        width: isSmallScreen ? 'auto' : '20%',
                        minWidth: 'auto',
                        flexGrow: 0
                    }
                },
                indicator: {
                    width: '100% !important',
                    maxWidth: '171px !important',
                    marginLeft: '15px !important',
                    backgroundColor: 'transparent !important',
                    background: 'linear-gradient(to right, #F5D01C, #826320) !important',
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    textTransform: 'none',
                    '&.Mui-selected': {
                        fontWeight: 500,
                        background: 'linear-gradient(to right, #F5D01C, #826320)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        color: 'transparent',
                    }
                }
            }
        }
    }
});

const UmsatzplanungTab = ({ slideLeft, slideRight, selectedTab, handleTabChange, weeks }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const themes = createCustomTheme(isSmallScreen);
    return (
        <div>
            <Box
                sx={{ paddingLeft: 0.5, marginBottom: 1 }}
            >
                <Button
                    onClick={slideLeft}
                    sx={{
                        padding: 0,
                        minWidth: 40
                    }}
                >
                    <img src={leftArrow} alt="Left Arrow" />
                </Button>
                <Button
                    onClick={slideRight}
                    sx={{
                        padding: 0,
                        minWidth: 40
                    }}
                >
                    <img src={rightArrow} alt="Right Arrow" />
                </Button>
            </Box>
            <ThemeProvider theme={themes}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="hidden"
                >
                    {weeks?.map((w, idx) => (
                        <RightAlignedTab className="right" key={w.label} label={w.label} />
                    ))}
                </Tabs>
            </ThemeProvider>
        </div>
    )
}

export default UmsatzplanungTab;
